// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3S98D","col":"CardReaderDesc_col__3Ugdv","label":"CardReaderDesc_label__OxhZu"};